const c = {
  name: "QatariRiyal",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13.4,18.4l-0.8-1.4l-0.1,0c-0.3,0.4-0.5,0.9-0.8,1.4c0.5,0.8,0.9,1.5,1.3,2.4c0.1,0.2,0.1,0.4,0.2,0.6
			c0,0.2,0,0.3-0.1,0.5c-0.3,0.8-0.8,1.5-1.5,2c-0.7,0.5-1.5,0.8-2.3,0.9c-0.4,0-0.8-0.1-1.2-0.2L8,24.8c0.8,0.5,1.8,0.8,2.8,0.9
			c0.3,0,0.7-0.1,1-0.3c0.3-0.2,0.6-0.4,0.8-0.7c0.8-0.8,1.3-1.9,1.4-3v-1.2C13.9,19.7,13.7,19,13.4,18.4z"/>
		<path class="st0" d="M16,21.3c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.2-0.3,0.3-0.5c0.1-0.1,0.3-0.2,0.4-0.3c0.2-0.1,0.3-0.1,0.5-0.1
			c0.3,0,0.6,0.1,0.8,0.2c0.2,0.1,0.4,0.4,0.5,0.6c0.1,0.3,0.2,0.5,0.1,0.8c0,0.3-0.2,0.5-0.4,0.7c-0.2,0.2-0.4,0.3-0.7,0.4
			c-0.3,0.1-0.6,0-0.8-0.1c-0.3-0.1-0.5-0.3-0.6-0.5C16.1,21.9,16,21.6,16,21.3z"/>
		<path class="st0" d="M25.9,20.2c0.6,0.4,1.3,0.5,2,0.5c0.4,0,0.8,0,1.2,0c0.1,0.2,0.1,0.4,0.1,0.6c0,0.3-0.7,0.9-1.3,1.3
			c-1,0.7-2.2,1-3.5,1c-0.5,0-0.9-0.1-1.4-0.3c-0.4-0.2-0.8-0.5-1.1-0.8c-0.3-0.3-0.6-0.8-0.7-1.2c-0.1-0.4-0.2-0.9-0.2-1.4
			c0-0.6,0.2-1.2,0.4-1.8L21.1,18c-0.4,0.9-0.6,2-0.6,3c0,0.5,0.1,1.1,0.3,1.6c0.2,0.5,0.5,1,0.9,1.3c0.4,0.4,0.8,0.7,1.3,0.9
			c0.5,0.2,1,0.3,1.6,0.3c1.7,0,3.3-0.7,4.5-1.8c0.4-0.3,0.6-0.7,0.8-1.2c0.1-0.5,0.2-1,0.2-1.5c0-0.9-0.2-1.8-0.5-2.6
			c-0.6-1.4-1.3-2.1-2.1-2.1c-0.4,0.1-0.7,0.2-1.1,0.4c-0.3,0.2-0.6,0.5-0.7,0.9c-0.2,0.4-0.4,0.8-0.4,1.3c0,0.3,0,0.7,0.1,1
			C25.5,19.7,25.7,20,25.9,20.2z M25.9,18.3c0-0.5,0.7-1,1.3-1v0c0.8,0,1.4,0.8,1.8,2c-0.3,0.1-0.7,0.1-1,0.1
			C26.5,19.3,25.9,18.8,25.9,18.3z"/>
		<path class="st0" d="M24.6,13.2c0.4,0.4,0.8,0.7,1.3,1.1c0.3-0.3,0.6-0.6,0.8-1c-0.4-0.4-0.8-0.8-1.2-1.2
			C25.1,12.5,24.9,12.8,24.6,13.2z"/>
		<path class="st0" d="M26.7,13.1c0.3-0.4,0.6-0.7,0.9-1c0.4,0.4,0.9,0.7,1.2,1.2c-0.2,0.3-0.5,0.6-0.8,0.9l0,0
			C27.5,13.8,27.1,13.4,26.7,13.1z"/>
		<path class="st0" d="M8.9,3.4C12.2,1.2,16,0,20,0c5.3,0,10.4,2.1,14.1,5.9S40,14.7,40,20c0,4-1.2,7.8-3.4,11.1
			c-2.2,3.3-5.3,5.9-9,7.4C24,40,20,40.4,16.1,39.6c-3.9-0.8-7.4-2.7-10.2-5.5c-2.8-2.8-4.7-6.4-5.5-10.2C-0.4,20,0,16,1.5,12.3
			C3,8.7,5.6,5.6,8.9,3.4z M10,35c3,2,6.4,3,10,3c4.8,0,9.4-1.9,12.7-5.3c3.4-3.4,5.3-8,5.3-12.7c0-3.6-1.1-7-3-10
			c-2-3-4.8-5.3-8.1-6.6C23.6,2,20,1.7,16.5,2.3C13,3,9.8,4.8,7.3,7.3C4.8,9.8,3,13,2.4,16.5C1.7,20,2,23.6,3.4,26.9S7,33,10,35z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as QatariRiyal
};
